import { render, staticRenderFns } from "./MarginsAccountingSummaryTab.vue?vue&type=template&id=1a175314&"
import script from "./MarginsAccountingSummaryTab.vue?vue&type=script&lang=js&"
export * from "./MarginsAccountingSummaryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports